module.exports = __webpack_public_path__ + "static/media/gett.897144db.png";